import React from 'react'
import { pluralizeToString } from 'lib/string/pluralize'
import Group from 'components/utils/Group'
import TextButton from 'components/Luxkit/Button/TextButton'
import BodyText from 'components/Luxkit/Typography/BodyText'
import LoadingAnimation from 'components/Common/Loading/LoadingAnimation'

interface Props {
  searchCount: number;
  fetchingSearchCount: boolean;
  onClear: () => void;
  onApply: () => void;
}

function CruiseLocationFooter({
  searchCount,
  fetchingSearchCount,
  onClear,
  onApply,
}: Props) {
  return <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="center">
    <BodyText variant="medium">
      {!fetchingSearchCount && `${pluralizeToString('cruise', searchCount)} available`}
      {fetchingSearchCount && <LoadingAnimation size={8} />}
    </BodyText>

    <Group direction="horizontal" horizontalAlign="end" gap={16}>
      <TextButton
        kind="tertiary"
        onClick={onClear}
      >
        Clear all
      </TextButton>
      <TextButton
        kind="primary"
        onClick={onApply}
      >
        Apply
      </TextButton>
    </Group>
  </Group>
}

export default CruiseLocationFooter
